module.exports = __webpack_public_path__ + "static/cro_app_icon-665beea61a8bf5b68a98fcb4e6a563fd.png";